(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-compact-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFilterAccordion(root) {
      var filters = root.querySelector('[data-ccl-filters]');
      if (!filters) return;

      var toggle = filters.querySelector('[data-ccl-filters-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          var isOpen = filters.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      }

      filters.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-filter-group-trigger]');
        if (!trigger) return;
        e.preventDefault();

        var group = trigger.closest('.collection-filters__filter-group');
        if (!group) return;

        var isOpen = group.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    function formatMoney(cents, format) {
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var formatted = parts.join('.');
      var formattedNoDecimals = parts[0];
      if (!format) return '$' + formatted;
      return format
        .replace(/\{\{\s*amount\s*\}\}/, formatted)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, formattedNoDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, formatted)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, formattedNoDecimals);
    }

    function cclGetStoredQty(variantId) {
      try {
        var raw = window.localStorage.getItem('cclQty:' + variantId);
        if (!raw) return 0;
        var parsed = JSON.parse(raw);
        return parsed && parsed.qty > 0 ? parsed.qty : 0;
      } catch (e) {
        return 0;
      }
    }

    function cclSetStoredQty(variantId, qty, price) {
      try {
        if (qty > 0) {
          window.localStorage.setItem('cclQty:' + variantId, JSON.stringify({ qty: qty, price: price || 0 }));
        } else {
          window.localStorage.removeItem('cclQty:' + variantId);
        }
      } catch (e) {}
    }

    function cclGetAllStored() {
      var results = [];
      try {
        for (var i = 0; i < window.localStorage.length; i++) {
          var key = window.localStorage.key(i);
          if (!key || key.indexOf('cclQty:') !== 0) continue;
          try {
            var parsed = JSON.parse(window.localStorage.getItem(key));
            if (parsed && parsed.qty > 0) {
              results.push({
                variantId: key.slice('cclQty:'.length),
                qty: parsed.qty,
                price: parsed.price || 0
              });
            }
          } catch (e) {}
        }
      } catch (e) {}
      return results;
    }

    function cclClearAllStoredQty() {
      try {
        var keysToRemove = [];
        for (var i = 0; i < window.localStorage.length; i++) {
          var key = window.localStorage.key(i);
          if (key && key.indexOf('cclQty:') === 0) keysToRemove.push(key);
        }
        keysToRemove.forEach(function (k) {
          window.localStorage.removeItem(k);
        });
      } catch (e) {}
    }

    function updateBulkBar(root) {
      var bar = root.querySelector('[data-ccl-bulk-bar]');
      if (!bar) return;
      var list = root.querySelector('[data-ccl-list]');

      /* Row highlighting only reflects what's on THIS page */
      if (list) {
        list.querySelectorAll('[data-product-row]').forEach(function (row) {
          var input = row.querySelector('[data-qty-input]');
          var qty = parseInt(input.value, 10);
          if (qty > 0) {
            row.classList.add('ccl-row--selected');
          } else {
            row.classList.remove('ccl-row--selected');
          }
        });
      }

      /* The bar's total is cumulative across every page in the session */
      var totalUnits = 0;
      var totalCents = 0;
      cclGetAllStored().forEach(function (entry) {
        totalUnits += entry.qty;
        totalCents += entry.qty * entry.price;
      });

      var summaryEl = bar.querySelector('[data-ccl-bulk-summary]');
      var btn = bar.querySelector('[data-ccl-bulk-btn]');
      var clearBtn = bar.querySelector('[data-ccl-bulk-clear]');
      var format = bar.getAttribute('data-money-format');

      if (totalUnits === 0) {
        summaryEl.textContent = '0 items selected';
        if (btn) btn.disabled = true;
        if (clearBtn) clearBtn.hidden = true;
        return;
      }

      if (btn) btn.disabled = false;
      if (clearBtn) clearBtn.hidden = false;
      var unitWord = totalUnits === 1 ? 'item' : 'items';
      summaryEl.innerHTML = totalUnits + ' ' + unitWord + ' &middot; <strong>' + formatMoney(totalCents, format) + '</strong>';
    }

    function initCompactList(root) {
      var list = root.querySelector('[data-ccl-list]');
      if (!list) return;

      var specsDelay = parseInt(list.getAttribute('data-specs-delay'), 10);
      if (isNaN(specsDelay)) specsDelay = 600;

      /* Restore any quantities saved from a previous visit */
      list.querySelectorAll('[data-product-row]').forEach(function (row) {
        var variantId = row.getAttribute('data-variant-id');
        var stored = cclGetStoredQty(variantId);
        if (stored > 0) {
          var qtyInput = row.querySelector('[data-qty-input]');
          qtyInput.value = stored;
          row.classList.add('ccl-row--selected');
        }
      });

      list.querySelectorAll('[data-specs-trigger]').forEach(function (trigger) {
        var row = trigger.closest('[data-product-row]');
        var popover = row ? row.querySelector('[data-specs-popover]') : null;
        if (!popover) return;

        var showTimer = null;

        /* Desktop only: hover. Disabled entirely on mobile, see CSS. */
        trigger.addEventListener('mouseenter', function () {
          clearTimeout(showTimer);
          showTimer = setTimeout(function () {
            popover.hidden = false;
          }, specsDelay);
        });

        trigger.addEventListener('mouseleave', function () {
          clearTimeout(showTimer);
          popover.hidden = true;
        });

        popover.addEventListener('mouseenter', function () {
          clearTimeout(showTimer);
        });

        popover.addEventListener('mouseleave', function () {
          popover.hidden = true;
        });
      });

      /* Safety net: force-close any open popover if the page is restored
         from back/forward navigation (bfcache) mid-hover/press */
      window.addEventListener('pageshow', function () {
        list.querySelectorAll('[data-specs-popover]').forEach(function (el) {
          el.hidden = true;
        });
      });

      list.addEventListener('click', function (e) {
        var decBtn = e.target.closest('[data-qty-decrease]');
        var incBtn = e.target.closest('[data-qty-increase]');
        if (!decBtn && !incBtn) return;

        var row = (decBtn || incBtn).closest('[data-product-row]');
        var input = row.querySelector('[data-qty-input]');
        var current = parseInt(input.value, 10);
        if (isNaN(current) || current < 0) current = 0;

        if (decBtn) current = Math.max(0, current - 1);
        if (incBtn) current = current + 1;

        input.value = current;
        var price = parseInt(row.getAttribute('data-variant-price'), 10) || 0;
        cclSetStoredQty(row.getAttribute('data-variant-id'), current, price);
        updateBulkBar(root);
      });

      list.addEventListener('input', function (e) {
        if (!e.target.matches('[data-qty-input]')) return;
        var val = parseInt(e.target.value, 10);
        if (isNaN(val) || val < 0) {
          val = 0;
          e.target.value = 0;
        }
        var row = e.target.closest('[data-product-row]');
        var price = parseInt(row.getAttribute('data-variant-price'), 10) || 0;
        cclSetStoredQty(row.getAttribute('data-variant-id'), val, price);
        updateBulkBar(root);
      });

      list.addEventListener('change', function (e) {
        if (!e.target.matches('[data-variant-select]')) return;
        var row = e.target.closest('[data-product-row]');
        var selectedOption = e.target.options[e.target.selectedIndex];
        var oldVariantId = row.getAttribute('data-variant-id');
        var newVariantId = e.target.value;
        var newPrice = parseInt(selectedOption.getAttribute('data-price'), 10) || 0;
        var qtyInput = row.querySelector('[data-qty-input]');
        var currentQty = parseInt(qtyInput.value, 10) || 0;

        row.setAttribute('data-variant-id', newVariantId);
        row.setAttribute('data-variant-price', newPrice);

        if (currentQty > 0) {
          cclSetStoredQty(oldVariantId, 0);
          cclSetStoredQty(newVariantId, currentQty, newPrice);
        }

        updateBulkBar(root);
      });
    }

    function initBulkBar(root) {
      var bar = root.querySelector('[data-ccl-bulk-bar]');
      var list = root.querySelector('[data-ccl-list]');
      if (!bar || !list) return;

      var btn = bar.querySelector('[data-ccl-bulk-btn]');
      var textEl = bar.querySelector('[data-ccl-bulk-btn-text]');
      var clearBtn = bar.querySelector('[data-ccl-bulk-clear]');

      updateBulkBar(root);

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          cclClearAllStoredQty();
          list.querySelectorAll('[data-qty-input]').forEach(function (input) {
            input.value = 0;
          });
          updateBulkBar(root);
        });
      }

      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        var items = cclGetAllStored().map(function (entry) {
          return { id: entry.variantId, quantity: entry.qty };
        });

        if (items.length === 0) return;

        var originalText = textEl.textContent;
        btn.classList.remove('is-success', 'is-error');
        btn.classList.add('is-loading');
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-success');
            textEl.textContent = 'Added! Redirecting…';
            cclClearAllStoredQty();
            window.location.href = '/cart';
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-error');
            textEl.textContent = 'Error';
            window.setTimeout(function () {
              btn.classList.remove('is-error');
              textEl.textContent = originalText;
              btn.disabled = false;
            }, 1800);
          });
      });
    }


    function updateCartCount() {
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        })
        .catch(function () {});
    }

    document.querySelectorAll('[data-ccl-section]').forEach(function (root) {
      initFilterAccordion(root);
      initCompactList(root);
      initBulkBar(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
